import {
  NestedAgency,
  NestedHome,
  ProviderType,
  StatusType,
} from "@habity/types";
import {
  getRelatedHomesFilters as getRelatedHomesFiltersHabity,
  BRAND_COLOR as BRAND_COLOR_HABITY,
  BREAKPOINTS as BREAKPOINTS_HABITY,
  FONTS as FONTS_HABITY,
  GLOBAL_STYLES as GLOBAL_STYLES_HABITY,
  getCuratedButtons as getCuratedButtonsHabity,
  getStatusIcon as getStatusIconHabity,
} from "./habity";
import {
  getRelatedHomesFilters as getRelatedHomesFiltersEO,
  BRAND_COLOR as BRAND_COLOR_EO,
  BREAKPOINTS as BREAKPOINTS_EO,
  CHAKRA_COLORS as CHAKRA_COLORS_EO,
  FONTS as FONTS_EO,
  GLOBAL_STYLES as GLOBAL_STYLES_EO,
  getCuratedButtons as getCuratedButtonsEO,
  getProjectCuratedButtons as getProjectCuratedButtonsEO,
  getStatusIcon as getStatusIconEO,
} from "./eo";

export const getLogoSrc = (identifier?: string | null) => {
  return `/${identifier || "habity"}/logos/logo.png`;
};

export const getCuratedButtons = (
  identifier?: string | null,
  signedIn?: boolean
) => {
  switch (identifier) {
    case "habity":
      return getCuratedButtonsHabity(signedIn);
    case "eo":
      return getCuratedButtonsEO(signedIn);
    default:
      return [];
  }
};

export const getProjectCuratedButtons = (identifier?: string | null) => {
  switch (identifier) {
    case "eo":
      return getProjectCuratedButtonsEO();
    default:
      return [];
  }
};

export const getStatusIcon = (
  identifier?: string | null,
  status?: StatusType
) => {
  switch (identifier) {
    case "habity":
      return getStatusIconHabity(status);
    case "eo":
      return getStatusIconEO(status);
    default:
      return null;
  }
};

export const getRelatedHomesFilters = (
  home: NestedHome,
  identifier: string | null
) => {
  switch (identifier) {
    case "habity":
      return getRelatedHomesFiltersHabity(home);
    case "eo":
      return getRelatedHomesFiltersEO(home);
    default:
      return null;
  }
};

export const getBreakpoints = (identifier?: string | null) => {
  switch (identifier) {
    case "habity":
      return BREAKPOINTS_HABITY;
    case "eo":
      return BREAKPOINTS_EO;
    default:
      return BREAKPOINTS_HABITY;
  }
};

export const getBrandColor = (identifier?: string | null) => {
  switch (identifier) {
    case "habity":
      return BRAND_COLOR_HABITY;
    case "eo":
      return BRAND_COLOR_EO;
    default:
      return BRAND_COLOR_HABITY;
  }
};

export const getChakraColors = (identifier?: string | null) => {
  switch (identifier) {
    case "eo":
      return CHAKRA_COLORS_EO;
    default:
      return {};
  }
};

export const getFonts = (identifier?: string | null) => {
  switch (identifier) {
    case "habity":
      return FONTS_HABITY;
    case "eo":
      return FONTS_EO;
    default:
      return FONTS_HABITY;
  }
};

export const getGlobalStyles = (identifier?: string | null) => {
  switch (identifier) {
    case "habity":
      return GLOBAL_STYLES_HABITY;
    case "eo":
      return GLOBAL_STYLES_EO;
    default:
      return GLOBAL_STYLES_HABITY;
  }
};

export const getProviderSettings = (
  agency: NestedAgency | null | undefined,
  provider: ProviderType
) => {
  if (!agency) return null;
  const { providers } = agency;
  return providers?.find((i) => i.name === provider)?.settings;
};

export const hasProvider = (
  agency: NestedAgency | null,
  name: ProviderType
) => {
  if (!agency) return false;
  const { providers } = agency || {};
  return providers?.some((p) => p.name === name);
};

export const getAgencyUrl = (agency: NestedAgency, isDev: boolean) => {
  if (!agency) return undefined;
  const { site_url } = agency;
  return site_url;
};
